import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-design-services',
  templateUrl: './design-services.component.html',
  styleUrls: ['./design-services.component.scss']
})
export class DesignServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scrollTo(0, 0)
  }

}
